import { __decorate, __metadata } from "tslib";
import { Component, Ref, Mixins, Inject } from 'vue-property-decorator';
import { getUserAccount, getLoginLocaleStatus, removeLoginLocaleStatus, } from 'library-components/services/localStorage';
import { registerUrlParamKeys } from 'library-components/apis/register/register.type';
import { startsWith } from 'lodash';
import { getVar, getAllVarsForLogin, postVar } from 'library-components/utils/environment';
import { E_LoginMethod } from 'library-components/apis/login/login.type';
import { postPreLoginCheckApi, postPreLoginMobileOrEmailVerifyCode, preMobileLoginApi } from 'library-components/apis/login/login';
import { E_Switch } from 'library-components/apis/passport/passport.type';
import { setLangValue } from 'library-components/utils/langUtils';
import { goToMoudle } from '../utils/goToMoudle';
import { E_MobileVerifyCodePurpose } from 'library-components/apis/passport/types';
import { bindWechatOpenIdApi } from 'library-components/apis/wechat/wechat';
import { Toast } from 'patsnap-biz';
import { ReCaptchaVerificationMixin } from 'library-components/mixins/reCaptchaVerificationMixin';
import { emailRe } from '../utils/regex';
import { E_ConfirmResult, TaskSource } from 'library-components/utils/task';
import { validateEmail } from 'library-components/utils/validator';
function makePasswordForm() {
    const email = getVar('account') || getUserAccount();
    const isEmail = emailRe.test(email);
    return {
        // 如果是邮箱才自动填充
        email: isEmail ? email : '',
        password: '',
    };
}
function makeSmsForm(locale, isFromFreemium) {
    return {
        mobile_number: '',
        verify_code: '',
        purpose: isFromFreemium ? E_MobileVerifyCodePurpose.LOGIN_REGISTER : E_MobileVerifyCodePurpose.LOGIN,
        country_code: '',
    };
}
let UserLoginMixin = class UserLoginMixin extends Mixins(ReCaptchaVerificationMixin) {
    constructor() {
        super(...arguments);
        this.formPassword = makePasswordForm();
        this.smsRules = {
            mobile_number: [
                { required: true, trigger: 'blur', message: this.$t('passport.register.required') },
                { min: 11, trigger: 'blur', message: this.$t('passport.mobileError') }
            ],
            verify_code: [
                { required: true, trigger: 'blur', message: this.$t('passport.register.required') }
            ],
        };
        // 是否进行极验
        this.isNeedCaptcha = false;
        this.termsOfServiceVisible = false;
        this.termsOfServiceUpdate = false;
        // 短信验证相关
        this.formSms = makeSmsForm(this.$i18n.locale, this.commonService.IsFromFreemium);
    }
    get PasswordRules() {
        return {
            email: [
                { required: true, trigger: 'blur', message: this.$t('passport.register.required') },
                {
                    validator: (rule, value, callback) => {
                        return validateEmail(this, value, callback);
                    },
                    trigger: 'blur',
                }
            ],
            password: [
                { required: true, trigger: 'blur', message: this.$t('passport.register.required') }
            ],
        };
    }
    get DefaultCountry() {
        return this.commonService.DefaultCountryCode;
    }
    getMobileLoginData({ username, country_code = '', mobile_number = '', ...otherData }) {
        if (!country_code) {
            if (startsWith(username, this.DefaultCountry)) {
                country_code = this.DefaultCountry;
                mobile_number = username.replace(country_code, '');
            }
            else {
                mobile_number = username;
            }
        }
        return { country_code: this.DefaultCountry, mobile_number, ...otherData };
    }
    async beforeLoginCheck(params, loginType, bindExistAccount = true) {
        this.isNeedCaptcha = false;
        let multiData;
        if (loginType === E_LoginMethod.password) {
            multiData = await postPreLoginCheckApi(params);
        }
        else if (loginType === E_LoginMethod.mobilePassword) {
            multiData = await preMobileLoginApi(params);
        }
        else if (loginType === E_LoginMethod.sms || loginType === E_LoginMethod.emailVerifyCode) {
            multiData = await postPreLoginMobileOrEmailVerifyCode(params);
        }
        else {
            console.error('Invalidate E_LoginMethod:', loginType);
        }
        /**
         * 绑定已存在账号，不提示
         * 如果是注册并登录，preLogin接口请求成功，需要提示账号已存在
         */
        if (!bindExistAccount && this.commonService.IsLoginProject) {
            const res = await this.$msgbox({
                message: this.$t('passport.wechat.registerErrorIsExistAccountMsg'),
                showCancelButton: true,
                cancelButtonClass: 'patsnap-el-cancel',
                confirmButtonClass: 'patsnap-el-confirm',
                confirmButtonText: this.$t('passport.wechat.bind'),
                cancelButtonText: this.$t('passport.common.cancel'),
                closeOnClickModal: false,
                showClose: false,
            }).catch((e) => {
                return e;
            });
            if (res !== 'confirm') {
                return;
            }
        }
        if (multiData) {
            const { exceeded, trial_terms, company_limited, need_captcha, token, strong_password_need, terms_update, } = multiData;
            this.isNeedCaptcha = need_captcha;
            if ((trial_terms || terms_update) && bindExistAccount) {
                // terms_update 为true trial_terms为false才弹最新条款
                const res = await this.trialTermsMsgBox(terms_update && !trial_terms);
                if (res !== E_ConfirmResult.CONFIRM) {
                    return;
                }
            }
            if (exceeded) {
                let message = this.$t('passport.logined_in_other_place');
                if (company_limited) {
                    message = this.$t('passport.maximum_company_logins_reached');
                }
                const res = await this.$msgbox({
                    message,
                    showCancelButton: true,
                    cancelButtonClass: 'patsnap-el-cancel',
                    confirmButtonClass: 'patsnap-el-confirm',
                    confirmButtonText: this.$t('passport.common.agree'),
                    cancelButtonText: this.$t('passport.common.cancel'),
                    closeOnClickModal: false,
                    showClose: false,
                }).catch((e) => {
                    return e;
                });
                if (res !== 'confirm') {
                    return;
                }
            }
            if (token) {
                window.location.href = this.getResetPasswordUrl({ ...params, token, strong_password_need }, loginType);
                return;
            }
            return true;
        }
    }
    trialTermsMsgBox(terms_update = false) {
        this.trialTermsMsgBoxSource = new TaskSource();
        this.termsOfServiceVisible = true;
        this.termsOfServiceUpdate = terms_update;
        return this.trialTermsMsgBoxSource.Promise;
    }
    onTermsOfServiceUpdateResult(result) {
        this.termsOfServiceVisible = false;
        this.trialTermsMsgBoxSource.Resolve(result);
    }
    /**
     * 跳转 强密码的 重置密码页
     */
    getResetPasswordUrl(params, loginType) {
        const registerParams = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
        const resetPasswordUrlQueries = {
            remember_me: E_Switch.On,
            token: params.token,
            strongPwd: params.strong_password_need,
        };
        if (loginType === E_LoginMethod.password) {
            resetPasswordUrlQueries.email = params.username;
        }
        if (loginType === E_LoginMethod.mobilePassword) {
            resetPasswordUrlQueries.mobile_number = params.mobile_number;
        }
        return `${this.commonService.AccountHost}/public/?${postVar(registerParams)}#/resetPassword?${postVar(resetPasswordUrlQueries)}`;
    }
    async onLoginSuccess(opts) {
        const { isBindWecaht, callbackValue } = opts;
        let bindWechatError = false;
        if (isBindWecaht) {
            await bindWechatOpenIdApi({ callback_value: callbackValue })
                .catch(err => {
                console.log('wechat bind err:', err);
                bindWechatError = true;
                Toast({
                    type: 'warning',
                    message: this.$t('passport.wechat.bindError'),
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    duration: 3000,
                });
            });
        }
        // if (opts?.notLogin) return
        setTimeout(async () => {
            const localeChanged = getLoginLocaleStatus();
            if (localeChanged) {
                try {
                    await setLangValue(this.$i18n.locale, true).then(() => {
                        removeLoginLocaleStatus();
                    });
                }
                catch (error) {
                    console.log(error);
                }
            }
            await goToMoudle(opts);
        }, bindWechatError ? 3000 : 0);
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], UserLoginMixin.prototype, "commonService", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], UserLoginMixin.prototype, "formSmsRef", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], UserLoginMixin.prototype, "formPasswordRef", void 0);
UserLoginMixin = __decorate([
    Component
], UserLoginMixin);
export { UserLoginMixin };
